import script from "./h-menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./h-menu.vue?vue&type=script&lang=ts&setup=true"

import "./h-menu.vue?vue&type=style&index=0&id=65e93a04&lang=scss"

const __exports__ = script;

export default __exports__